import { TranslateService } from '@ngx-translate/core';
import { Notification, NotificationData } from './notification.model';

export class BookingNotification extends Notification {
  constructor(
    data: NotificationData,
    private readonly translateService: TranslateService,
  ) {
    super(data);
    this.actionName = this.translateService.instant('view_booking');
    this.actionRequired = this.booking.date.diffNow().milliseconds <= 0;
    this.description =
      this.booking.date.diffNow().milliseconds >= 0
        ? this.translateService.instant('booking_upcomming_description', {
            doctor: this.booking.doctor.fullName,
            time: this.booking.date.toFormat('HH:mm'),
            date: this.booking.date.toFormat('cccc, dd LLLL'),
          })
        : this.translateService.instant('booking_past_description', {
            doctor: this.booking.doctor.fullName,
            time: this.booking.date.toFormat('HH:mm'),
            date: this.booking.date.toFormat('cccc, dd LLLL'),
          });
  }
}
